export default {
    photographerUpload: {
        list: [],
        metadata: {
            saved: false,
            idList: []
        },
        failed: {
            list: []
        }
    }
};
